export default "__VITE_ASSET__CICDBlZr__"